import React from 'react';
import graphql from "babel-plugin-relay/macro";
import {useMutation} from "react-relay";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import FormModal from "../../../components/common/modals/FormModal";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";

const NewFacilityLocationPracticePeriodModal = ({showModal, onClose, facilityLocationId}) => {
    const mutation = graphql`
    mutation NewFacilityLocationPracticePeriodModalMutation($facilityLocationId: ID!, 
        $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
      facilityLocation {
          createPracticePeriod(input: {facilityLocationId: $facilityLocationId, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
              facilityLocationPracticePeriod {
                  id
                  facilityLocation {
                      practicePeriods {
                          ...FacilityLocationPracticePeriods_PracticePeriod
                      }}}}}}`
    const [commitMutation, isInFlight] = useMutation(mutation);
    const defaultValues = {
        ...newBandDefaultValues,
        facilityLocationId: facilityLocationId,
    }
    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(bandedSchema)});
    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.facilityLocation) {
                    toast.success("Practice Period for Provider Location created")
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"New Practice Period"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
        >
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
export default NewFacilityLocationPracticePeriodModal
